module.exports = __webpack_public_path__ + "img/trash-empty.ffc7f0e7.png";